import { useDesktopMode } from "@/stores/desktop-mode-store";

interface RailPanModeActionOptions {
  denkMode: boolean;
  denkCanvasCaptureActive: boolean;
  toggleCanvasPanMode: () => void;
}

export function runRailPanModeAction({
  denkMode,
  denkCanvasCaptureActive,
  toggleCanvasPanMode,
}: RailPanModeActionOptions) {
  if (denkMode) {
    useDesktopMode.getState().setDenkCanvasCapture(!denkCanvasCaptureActive);
    return;
  }
  toggleCanvasPanMode();
}
